<template>
    <div @dblclick="toggleEditable">
         <span v-if="isEditable">
            <select class="border rounded-md" @change="handleInputChange" :value="clientContact.time_zone" name="" id="">
                <option :value="null">-------</option>
                <option value="UTC-09:00 (AKT) - Most of the state of Alaska">UTC-09:00 (AKT) - Most of the state of Alaska</option>
                <option value="UTC-08:00 (PT) - Pacific Time zone">UTC-08:00 (PT) - Pacific Time zone</option>
                <option value="UTC-07:00 (MT) - Mountain Time zone">UTC-07:00 (MT) - Mountain Time zone</option>
                <option value="UTC-06:00 (CT) - Central Time zone">UTC-06:00 (CT) - Central Time zone</option>
                <option value="UTC-05:00 (ET) - Eastern Time zone">UTC-05:00 (ET) - Eastern Time zone</option>                   
            </select>
        </span>
        <span v-else >{{ contactTimeZone }}</span>
    </div>
</template>

<script setup>
import {ref, computed, defineProps, defineEmits, watch} from "vue";
import {updateContactClientRelationship} from '@/services/Contact.js'
import { useStore } from "vuex";

  const isEditable = ref(false)

  const store = useStore()

  const props = defineProps(['clientContact'])

  const emit = defineEmits(['refetch-clients'])

  function fetchNewClients () {
      emit('refetch-clients')
  }

  function toggleEditable () {
      isEditable.value = !isEditable.value
  }


  const contactTimeZone = computed(() => {
    return props.clientContact.time_zone ? props.clientContact.time_zone : "--"
  })

  async function handleInputChange(e) {
            let newValue = e.target.value
            const targetField = "time_zone"
            let updatedData = {}
            updatedData[targetField] = newValue
            const data = JSON.stringify(updatedData);
            console.log('data', data)
            let token = store.state.auth.token
            console.log('new value', newValue)
            await updateContactClientRelationship(props.clientContact.id, data, token)
            emit('refetch-clients')
            isEditable.value = false

        }

</script>